import apiClient from "../utils/ApiClient";

export const getTransactionList = async (currentPage,itemsPerPage) => {
    try {
        const response = await apiClient.get(`/api/payment-history-list?page=${currentPage}&listData=${itemsPerPage}`)
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};